import qs from 'qs';

export const stringifyBracketParameter = (value: Record<string, any>) =>
  qs.stringify(value, {
    arrayFormat: 'brackets',
    encodeValuesOnly: true,
    skipNulls: true,
    // Keep empty-array filters (e.g. `in: []`) on the wire instead of dropping them.
    allowEmptyArrays: true,
  });
